export enum PLAN_TAG_NAMES {
    plan_sowo = 'B&You',
    plan_pro_sowo = 'B&You',

    plan_simo = 'Sensation_sim_seule',
    plan_pro_simo = 'Sensation_sim_seule',

    plan_premium = 'Sensation_avantages_smartphone',
    plan_pro_premium = 'Sensation_avantages_smartphone',
}
